import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { UserContract } from 'apis/merchant-onboarding-service/types';

import { BREAKPOINT_MOBILE } from '../constants';

type Props = {
  userContracts: UserContract[];
};

const Row = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  max-width: 620px;
  width: 100%;
  justify-content: space-between;
  padding: 10px;

  @media (min-width: ${BREAKPOINT_MOBILE + 1}px) {
    flex-direction: row;
  }
`;

const Name = styled.div`
  font-weight: 700;
  font-size: 18px;
`;

const Description = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding-block-start: 10px;
`;

const LeftColumn = styled.div`
  display: flex;
  flex-flow: column;
`;

const SigningUrl = styled.a`
  display: block;
  border-radius: 8px;
  padding: 18px 32px;
  background: #009de0;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    width: 100%;
    margin-block-start: 18px;
  }
`;

const Container = styled.div`
  background: #009de014;
  border-radius: 8px;
  padding: 8px;
`;

const ContractLinks = ({ userContracts }: Props) => {
  return (
    <Container>
      {userContracts.map((userContract, idx) => (
        <Row key={idx}>
          <LeftColumn>
            <Name>{userContract.merchantName}</Name>
            <Description>
              <FormattedMessage id="merchant-sign-up.contract-links.wolt-partner-contract" />
            </Description>
          </LeftColumn>
          <SigningUrl
            data-testid={`merchant-sign-up-contract-links-review-and-sign-link-${idx}`}
            href={userContract.signingUrl}
            target="_blank"
          >
            <FormattedMessage id="merchant-sign-up.contract-links.review-and-sign" />
          </SigningUrl>
        </Row>
      ))}
    </Container>
  );
};

export default ContractLinks;
